/**
 * Detail bundle for a single `:LogicSolver` (`$solverId` param).
 *
 * Returns:
 *   - `solver`     — the node itself
 *   - `site`       — `[:PART_OF]->(:Site)`
 *   - `fldRows`    — contained FLDs with SafetyPoint counts
 *   - `functions`  — `(:ProtectiveFunction)-[:SOLVED_BY]->` this solver
 *
 * Bounded by `LIMIT 1`. Related lists are collected.
 */
export const PLANT_LOGIC_SOLVER_DETAIL_CYPHER = `
            MATCH (ls:LogicSolver {id: $solverId})
            OPTIONAL MATCH (ls)-[:PART_OF]->(site:Site)
            OPTIONAL MATCH (pf:ProtectiveFunction)-[:SOLVED_BY]->(ls)
            WITH ls, site, collect(distinct pf) AS functions
            OPTIONAL MATCH (ls)-[:CONTAINS]->(fld:FunctionLogicDiagram)
            OPTIONAL MATCH (fld)-[:CONTAINS]->(sp:SafetyPoint)
            OPTIONAL MATCH (impl:ProtectiveFunction)-[:IMPLEMENTED_BY]->(fld)
            WITH ls, site, functions, fld,
                 count(distinct sp) AS pointCount,
                 collect(distinct impl) AS implementedBy
            RETURN ls AS solver,
                   site,
                   functions,
                   collect(CASE WHEN fld IS NULL THEN null ELSE {
                     diagram: fld,
                     pointCount: pointCount,
                     implementedBy: implementedBy
                   } END) AS fldRows
            LIMIT 1
          `
